var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useConfig } from "@/composables/config";
import localize from "@/utils/localization";
import { wait } from "@/utils/utils";
import { useCleanupCategories } from "./Cleanup/categories";
import CleanupOperationSummary from "./Cleanup/CleanupOperationSummary.vue";
import CleanupResultDialog from "./Cleanup/CleanupResultDialog.vue";
import ReviewCleanupDialog from "./Cleanup/ReviewCleanupDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StorageManager',
    setup(__props) {
        const { config } = useConfig();
        const { cleanupCategories } = useCleanupCategories();
        const currentOperation = ref();
        const currentTotalItems = ref(0);
        const cleanupResult = ref();
        const refreshOperationId = ref();
        const reviewModal = ref(null);
        const resultModal = ref(null);
        const issuesUrl = "https://github.com/galaxyproject/galaxy/issues";
        function onReviewItems(operation, totalItems) {
            var _a;
            currentOperation.value = operation;
            currentTotalItems.value = totalItems;
            refreshOperationId.value = undefined;
            (_a = reviewModal.value) === null || _a === void 0 ? void 0 : _a.openModal();
        }
        function onConfirmCleanupSelected(selectedItems) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                cleanupResult.value = undefined;
                (_a = resultModal.value) === null || _a === void 0 ? void 0 : _a.openModal();
                yield wait(1000);
                if (currentOperation.value) {
                    cleanupResult.value = yield currentOperation.value.cleanupItems(selectedItems);
                    if (cleanupResult.value.hasUpdatedResults) {
                        refreshOperationId.value = currentOperation.value.id.toString();
                    }
                }
            });
        }
        return { __sfc: true, config, cleanupCategories, currentOperation, currentTotalItems, cleanupResult, refreshOperationId, reviewModal, resultModal, issuesUrl, onReviewItems, onConfirmCleanupSelected, localize, CleanupOperationSummary, CleanupResultDialog, ReviewCleanupDialog };
    }
});
